// extracted by mini-css-extract-plugin
export default {"commentContainer":"Comment_commentContainer__E1vNL","commentTitle":"Comment_commentTitle__RGc-Z"};